import React from "react";
import ReactDOM from "react-dom";

import $ from "jquery";
import _ from "underscore";

import ActionBar from "./action_bar";
import MultiSelectFilterContainer from "shared/react_components/MultiSelectFilterContainer";

class MultiSelectFiltersActionBar extends ActionBar {
  _appendFilters($filterEl) {
    const target = $('<div class="filter-area-item flex-container">');
    $filterEl.append(target);
    this._buildMultiSelectFilters(target);
  }

  _buildMultiSelectFilters(target) {
    // Initial values can be provided via `selections` option to ActionTable, or by setting model if instantiating ActionBar directly
    const filters = this._organizeFiltersFromConfig();

    const container = React.createElement(MultiSelectFilterContainer, {
      filters: filters.visibleFilters,
      paramFilters: filters.initialFilters,
      callback: this._newFiltersCallback(filters.allFilterKeys).bind(this),
      enabled: true,
      hideLabels: true,
      titlePrefix: "",
      shouldSort: true
    });

    ReactDOM.render(container, target.get(0));
  }

  _organizeFiltersFromConfig() {
    let allFilterKeys = [];
    let initialFilters = {};
    let visibleFilters = {};

    this.multiSelectFilterConfig.forEach((filter) => {
      allFilterKeys.push(filter.attr);

      if (this.model.get(filter.attr)) {
        initialFilters[filter.attr] = _.flatten([this.model.get(filter.attr)]);
      }

      const visibleFilter = this._validateVisibleFilter(filter);
      if (visibleFilter) {
        visibleFilters[filter.attr] = visibleFilter;
      }
    });

    return { allFilterKeys: allFilterKeys, initialFilters: initialFilters, visibleFilters: visibleFilters };
  }

  _validateVisibleFilter(filter) {
    if (_.isUndefined(filter.present) || _.result(filter, 'present')) {
      return {
        url: _.result(filter, 'url'),
        values: _.result(filter, 'values'),
        friendlyName: filter.friendlyName,
        allSelectedText: filter.allSelectedText
      };
    }
  }

  _newFiltersCallback(allFilterKeys) {
    return function(newFilters) {
      const currentFilterKeys = _.intersection(allFilterKeys, Object.keys(this.model.attributes));
      const filterKeysToRemove = _.difference(currentFilterKeys, Object.keys(newFilters));
      const filtersToRemove = _.object(_.map(filterKeysToRemove, (key) => { return [key, null]; }));

      this.model.set(_.extend({}, newFilters, filtersToRemove));
    };
  }
}

export default MultiSelectFiltersActionBar;
